module.exports = __webpack_public_path__ + "components/patterns/collectionObjectInfoArea/arrow7.png";